import { API_ENDPOINTS } from "../ApiEndPoints";
import axios from "axios";

const categoriesUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.CATEGORIES}`;
const brandUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.BRANDS}`;

// Function to fetch all categories
export const fetchAllCategories = async () => {
  try {
    const response = await axios.get(categoriesUrl);
    if (response.status === 200) {
      return response.data.data; // Assuming the API response follows your provided structure
    } else {
      throw new Error("Failed to fetch categories");
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const fetchAllBrands = async () => {
  try {
    const response = await axios.get(brandUrl);
    console.log("response: ", response);
    if (response.status === 201) {
      return response.data; // Assuming the API response follows your provided structure
    } else {
      throw new Error("Failed to fetch categories");
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
